import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/scss/main.scss";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';



const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/clipneststudio/">
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals(); 